export function getNegationPrefix(config) {
    return config.negate ? 'NOT ' : '';
}
